<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_category mb-3 rounded-lg">
          <div>
            <v-col>
              <v-col class="ml-3" cols="12">
                <p>Banner</p>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-col cols="6">
                        <v-file-input
                            label="Ảnh desktop"
                            placeholder="Tải ảnh lên"
                            prepend-icon="mdi-camera"
                            @change="fileBannerDesktop"
                        ></v-file-input>
                      </v-col>
                      <v-img :src="src"></v-img>
                    </v-col>
                    <v-col cols="6">
                      <v-col cols="6">
                        <v-file-input
                            label="Ảnh mobile"
                            placeholder="Tải ảnh lên"
                            prepend-icon="mdi-camera"
                            @change="fileBannerMobile"
                        ></v-file-input>
                      </v-col>
                      <v-img :src="src1"></v-img>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
              <v-col class="ml-3" cols="12">
                <v-select
                    background-color="#EDF2F7"
                    filled
                    item-text="text"
                    v-model="typeLink"
                    :items="types"
                    item-value="id"
                    label="Chọn loại Link"
                ></v-select>
              </v-col>
              <v-col class="ml-3" cols="12" v-show="typeLink == 2">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    v-model="url"
                    item-text="name"
                    item-value="id"
                    label="Nhập đường dẫn"
                ></v-text-field>
              </v-col>
              <v-col class="ml-3" cols="12" v-show="typeLink == 1">
                <v-select
                    background-color="#EDF2F7"
                    filled
                    item-text="name"
                    v-model="select_type"
                    :items="modlues"
                    item-value="id"
                    label="Chọn loại"
                ></v-select>
              </v-col>
              <v-col class="ml-3" cols="12" v-show="typeLink == 1">
                <v-autocomplete
                    background-color="#EDF2F7"
                    filled
                    v-model="slugSelect"
                    item-text="name"
                    item-value="slug"
                    :items="list_ids"
                    label="Chọn ID"
                ></v-autocomplete>
              </v-col>
            </v-col>
          </div>
        </v-col>
      </v-row>
      <v-col cols="12" class="text-center mt-3">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import {
  GET_LIST_CONFIG_ADVISE,
  UPDATE_LIST_CONFIG_ADVISE,
  UPLOAD_ADVISE_IMAGE,
} from "@/store/modules/configs";
import { GET_LIST_BRAND } from "@/store/modules/brand";
import { GET_LIST_TAG } from "@/store/modules/tag";
export default {

  data() {
    return {
      banner_:{},
      type_id: null,
      url:null,
      list_ids: null,
      select_type: null,
      typeLink: null,
      photo_url: "",
      photo_url_mobile: "",
      link: {
        brand_slug: null,
        type: '',
        object_id: null,
        url:null,
      },
      slugSelect: null,
      modlues: [
        {
          id: "category",
          name: "category",
        },
        {
          id: "brand",
          name: "brand",
        },
        {
          id: "tag",
          name: "tag",
        },
      ],
      list_type: [
        {
          id: "category",
          text: "category",
        },
        {
          id: "brand",
          text: "brand",
        },
        {
          id: "tag",
          text: "tag",
        },
      ],
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      image: {},
      src: "",
      src1:"",
      src_banner_mobile: "",
      src_banner_desktop: "",
      category: {
        id: -1,
      },

      page: "Quản lý yêu cầu tư vấn",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Yêu cầu tư vấn",
          disabled: true,
        },
      ],
      errors: 0,
      text_seo: "",
      SEO: [],
    };
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      config_advise: "config_advise",
      //   category: "categoryDetail",
      //   brands: "brands",
      //   tags: "tags",
      //   seos: "seos",
    }),
  },
  watch: {
    config_advise(val) {
      this.src1 = val.photo_url_mobile_path;
      this.src= val.photo_url_path;
      this.properties = val.properties;
      this.collections = val.collection;
      this.banner_ = val;
      this.url = val.link.url;
      this.typeLink = val.type;
      this.slugSelect = val.link.object_id;
      this.select_type = val.link.type;
    },
    select_type(val) {
      this.link.type = val;
      const _this = this;
      let url = "";
      if (val == "category") {
        url = GET_LIST_CATEGORY;
      }
      if (val == "brand") {
        url = GET_LIST_BRAND;
      }
      if (val == "tag") {
        url = GET_LIST_TAG;
      }
      if (url != "") {
        this.$store.dispatch(url).then((data) => {
          if (data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.dispatch(`${GET_LIST_CONFIG_ADVISE}`);
  },
  mounted() {},
  methods: {
    fileBannerDesktop(event) {
      const _this = this;
      if (!event) {
        this.src = '';
        this.photo_url = "";
      }
      this.src=URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_ADVISE_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.photo_url = element.path;
          })
        }
      })
    },
    fileBannerMobile(event) {
      const _this = this;
      if (!event) {
        this.src1 = '';
        this.photo_url_mobile = "";
      }
      this.src1=URL.createObjectURL(event);
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "banners");
      this.$store.dispatch(`${UPLOAD_ADVISE_IMAGE}`, formData).then((data) => {
        if (data && data.data && data.data.data) {
          data.data.data.forEach(element => {
            _this.photo_url_mobile = element.path;
          })
        }
      })
    },

    save() {
      this.updateLink();
      if(this.typeLink == 1) {
        this.link = {
          brand_slug: this.link.brand_slug,
          type: this.select_type,
          object_id: this.slugSelect,
          url:null
        }
      }
      if(this.typeLink == 2) {
         this.link  = {
          brand_slug: null,
          type: null,
          object_id: null,
          url: this.url,
        }
      }
      let body = {
        type: this.typeLink,
        photo_url: this.photo_url ?  this.photo_url : this.config_advise.photo_url,
        photo_url_mobile: this.photo_url_mobile ? this.photo_url_mobile : this.config_advise.photo_url_mobile,
        link: this.link
      };

      this.$store.dispatch(`${UPDATE_LIST_CONFIG_ADVISE}`, body).then((data) => {
        if (data.status === 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$store.dispatch(`${GET_LIST_CONFIG_ADVISE}`);
        } else {
          alert(data.errors);
        }
      });
    },
    check(val) {
      this.banner_ = val.banner;
    },
    updateLink(){
      this.link.brand_slug = null;
      if(this.link.type == "category"){
        let category = this.list_ids.find(item =>{
          return item.slug == this.slugSelect
        })
        this.link.brand_slug = category.brand_slug;
      }
    }
  },
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
</style>